/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CompetenceCompetenceidLangsAvailableLanguages200,
  GetApiV1CompetenceCompetenceidLangsAvailableLanguages401,
  GetApiV1CompetenceCompetenceidLangsAvailableLanguages404,
  GetApiV1CompetenceCompetenceidLangsAvailableLanguages500,
  GetApiV1CompetenceCompetenceidLangsAvailableLanguagesPathParams,
  GetApiV1CompetenceCompetenceidLangsAvailableLanguagesQueryResponse,
} from "../../types/competenceIdiomasController/GetApiV1CompetenceCompetenceidLangsAvailableLanguages.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1CompetenceCompetenceidLangsAvailableLanguagesPathParamsSchema =
  z.object({
    competenceId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsAvailableLanguagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CompetenceCompetenceidLangsAvailableLanguages200Schema =
  z.array(
    z.lazy(() => dropDownListStringKeyViewModelSchema),
  ) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CompetenceCompetenceidLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsAvailableLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CompetenceCompetenceidLangsAvailableLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsAvailableLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CompetenceCompetenceidLangsAvailableLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsAvailableLanguages500>;

export const getApiV1CompetenceCompetenceidLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1CompetenceCompetenceidLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsAvailableLanguagesQueryResponse>;
